var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.059 20.058",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-paint-brush",
    "data-name": "Icon awesome-paint-brush",
    d: "M6.543,12.119a3.965,3.965,0,0,0-3.808,2.832.6.6,0,0,1-.572.391C1.729,15.342.383,14.258,0,14c0,3.226,1.486,6.062,5.015,6.062,2.972,0,5.015-1.715,5.015-4.709a3.394,3.394,0,0,0-.038-.358ZM17.938,0a2.392,2.392,0,0,0-1.575.644C8.355,7.8,7.522,7.966,7.522,10.072a3.627,3.627,0,0,0,.342,1.516l2.5,2.083a3.6,3.6,0,0,0,.877.119c2.433,0,3.844-1.781,8.273-10.047a4.031,4.031,0,0,0,.545-1.8A2.04,2.04,0,0,0,17.938,0Z",
    transform: "translate(0.001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "static/media/Brush.8ab540e30bf7fd22cf1a8b6b6b7ddba5.svg";
export { ForwardRef as ReactComponent };